import Button from '@/common/components/base/button/Button';
import LoadingButton from '@/common/components/base/button/loadingButton';
import MainModal from '@/common/components/base/modal/Modal';
import TitleDescription from '@/common/components/base/typography/TitleDescription';
import { DetailCardItemData } from '@/common/components/DetailCard/DetailCard.types';
import DetailCardItems from '@/common/components/DetailCard/DetailCardItems';
import React from 'react';
import { Box } from 'styled-system/jsx';

type params = {
  isSuccess: boolean;
  showPersonalDataModal: boolean;
  inquiryCardDataState: DetailCardItemData[] | undefined;
  onCloseModal: () => void;
  setData: () => void;
};

const ShowInquiryData: React.FC<params> = ({
  inquiryCardDataState,
  isSuccess,
  showPersonalDataModal,
  onCloseModal,
  setData,
}) => {
  return (
    <MainModal open={showPersonalDataModal} closeModal={() => onCloseModal()}>
      {isSuccess && (
        <Box>
          <TitleDescription>استعلام اطلاعات پایه راننده</TitleDescription>
          <Box
            mt={16}
            px={8}
            py={16}
            border="1px solid"
            borderRadius="8px"
            borderColor="purple-3"
            gap={30}
          >
            <DetailCardItems
              items={inquiryCardDataState ?? []}
              backgroundColor="purple-3"
            />
          </Box>
          <Box
            display="flex"
            alignItems="start"
            justifyContent="space-between"
            gap={8}
            mt={32}
          >
            <Button
              variant="outlined"
              color="common"
              w={'50%'}
              onClick={() => {
                onCloseModal();
              }}
            >
              ثبت دستی اطلاعات
            </Button>
            <LoadingButton
              type="submit"
              loading={false}
              w={'50%'}
              onClick={() => {
                setData();
              }}
            >
              تایید و ادامه
            </LoadingButton>
          </Box>
        </Box>
      )}
    </MainModal>
  );
};

export default ShowInquiryData;
